var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMyExamSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "prefix__Icon_-_My_Exam_-_Selected",
    width: 24,
    height: 24,
    "data-name": "Icon - My Exam - Selected",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-1{fill:#fff;opacity:0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "prefix__icon",
    d: "M0 0H24V24H0z",
    className: "prefix__cls-1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Icon_-_My_Exam_-_Selected-2",
    "data-name": "Icon - My Exam - Selected",
    transform: "translate(1.714 3.429)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__frame",
    d: "M0 0H20.571V17.143H0z",
    className: "prefix__cls-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Group_3609",
    "data-name": "Group 3609"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_6224",
    fill: "none",
    d: "M12 2v7.2a1.5 1.5 0 0 0 2.255 1.3L16 9.482l1.745 1.018A1.5 1.5 0 0 0 20 9.2V2a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2z",
    "data-name": "Path 6224",
    transform: "translate(-2.571)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Union_41",
    fill: "rgba(0,0,0,0)",
    stroke: "none",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-name": "Union 41"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.57 16.143H4c-1.654 0-3-1.346-3-3V2.855l.02-.142C1.16 1.736 2.011 1 3 1H6.43c.989 0 1.84.736 1.98 1.713l.123.858h8.039c1.654 0 3 1.346 3 3v6.572c0 1.654-1.346 3-3 3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#22b560",
    d: "M16.57 15.143c1.104 0 2.001-.897 2.001-2V6.572c0-1.103-.897-2-2-2H9.399c-.995 0-1.84-.732-1.98-1.718-.07-.487-.495-.854-.99-.854H3c-.495 0-.921.367-.99.854L2 2.92v10.224c0 1.103.897 2 2 2h12.57m0 2H4c-2.209 0-4-1.79-4-4V2.57h.03C.238 1.117 1.49 0 3 0H6.43C7.94 0 9.19 1.117 9.399 2.571h7.172c2.21 0 4 1.791 4 4v6.572c0 2.21-1.79 4-4 4z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Line_406",
    fill: "none",
    stroke: "#f8d248",
    strokeLinecap: "round",
    strokeWidth: "2px",
    d: "M0 0L11 0",
    "data-name": "Line 406",
    transform: "translate(4.786 12.429)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMyExamSelected);
export default __webpack_public_path__ + "static/media/icon-my-exam-selected.a04b31b7890f65a755b574fbc18a27c3.svg";
export { ForwardRef as ReactComponent };